import React from 'react';
import classNames from 'classnames';

import './styles.css';

const Notice = ({
  className,
  noticeIcon,
  noticeText,
  noticeAction,
  noticeActionText
}: any) => {
  return (
    <div className={classNames(className, 'Notice')}>
      <img src={noticeIcon} className="NoticeIcon" alt="notice" />
      <div className="message">
        <p>{noticeText}</p>
        {noticeAction && (
          <p className="action">
            <span className="colab-link" onClick={noticeAction}>
              {noticeActionText}
            </span>
          </p>
        )}
      </div>
    </div>
  );
};

export default Notice;
